export const CARACTERISTICAS_FUENTE_KIT = {
  ModoHibrido: null,
  amper12v: null,
  certi80plus: null,
  color: null,
  compatible_abajo: 0,
  digital: 0,
  disponible: 1,
  floppy: null,
  id_producto: 1,
  iluminacion: null,
  incluye_cable: 1,
  kit: 1,
  marca: 'Fuente KIT',
  molex: null,
  pines_pcie: 0,
  pines_pcieplus: 0,
  sata: 2,
  tipo: 'ATX',
  tipocableado: null,
  w_nominal: 500,
  w_real: 192,
  _4pines: 1,
  _4plus: 0,
  _24pines: 1,
  pcie_16pines: 0,
};
